import { render } from "./AboutUsHomePageBigScreen.vue?vue&type=template&id=177efa1f"
import script from "./AboutUsHomePageBigScreen.vue?vue&type=script&lang=js"
export * from "./AboutUsHomePageBigScreen.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__